export default function() {
  return new Worker(__webpack_public_path__ + "parsePixelDataToBlockchainTransactionData.worker.0d237a2a0bd8abbcfb03.worker.js");
}
